<table class="w-full text-left rtl:text-right text-gray-500">
	<thead class="text-white bg-emerald-500 semi-bold sticky top-0 z-10 text-sm">
		<tr>
			<th class="px-2 py-2"></th>
			<th class="px-2 py-2"></th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'ClientName', direction: sortConfig.direction })">
				Client
				<i [class]="getSortIconClass('ClientName')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'Subject', direction: sortConfig.direction })">
				Subject
				<i [class]="getSortIconClass('Subject')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2">Type</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'DueDate', direction: sortConfig.direction })">
				Due
				<i [class]="getSortIconClass('DueDate')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2">CSR</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'CompleteDate', direction: sortConfig.direction })">
				Completed
				<i [class]="getSortIconClass('CompleteDate')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2"><i class="far fa-trash-alt"></i></th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="
				let task of byClientRouteAndSearchActive
					? byClientSearchResults
					: (tasks
					  | paginate
							: {
									itemsPerPage: 25,
									currentPage: viewStateService.state.pageNumber,
									totalItems: csrTasksService.totalItems
							  })
			"
			class="bg-white border-b text-[12px] xl:text-sm"
		>
			<td class="py-2 px-2">
				<button
					(click)="onEditClick(task)"
					class="!w-auto px-4 text-black bg-gray-200 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm py-2.5 me-2"
				>
					Edit
				</button>
			</td>
			<td class="py-2 px-2">
				<button
					(click)="onCompleteClick(task)"
					[ngClass]="{ 'blue-bg': !task.CompleteDate, 'bg-blue-900 hover:bg-blue-800': !!task.CompleteDate }"
					class="!w-lg text-white focus:outline-hidden focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm py-2.5 me-2"
				>
					{{ !!task.CompleteDate ? 'Uncomplete' : 'Complete' }}
				</button>
			</td>
			<td class="py-2 px-2">
				<p
					[ngClass]="{ 'line-through': !!task.CompleteDate }"
					(click)="onClientNameClick(task)"
					class="flex items-center text-black cursor-pointer hover:text-blue-500 hover:underline"
				>
					{{ task.Client.Name }}
				</p>
			</td>
			<td class="py-2 px-2">
				<p [ngClass]="{ 'line-through': !!task.CompleteDate }" class="flex items-center text-black">{{ task.Subject }}</p>
			</td>
			<td class="py-2 px-2">
				<p [ngClass]="{ 'line-through': !!task.CompleteDate }" class="flex items-center text-black">{{ task.CsrTaskType.Name }}</p>
			</td>
			<td class="py-2 px-2">
				<p [ngClass]="{ 'line-through': !!task.CompleteDate }" class="flex items-center text-black">{{ task.dueDateView }}</p>
			</td>
			<td class="py-2 px-2">
				<p [ngClass]="{ 'line-through': !!task.CompleteDate }" class="flex items-center text-black">{{ task.Csr.UserName }}</p>
			</td>
			<td class="py-2 px-2">
				<p [ngClass]="{ 'line-through': !!task.CompleteDate }" class="flex items-center text-black">{{ task.completeDateView }}</p>
			</td>
			<td class="py-2 px-2">
				<button (click)="onDeleteClick(task)" class="text-red-500 hover:text-white border border-red-500 hover:bg-red-700 focus:ring-red-300 px-2">
					Delete
				</button>
			</td>
		</tr>
	</tbody>
</table>

<div *ngIf="tasks?.length > 0" class="flex justify-between items-center mt-2 mb-[100px]">
	<div>
		<pagination-controls (pageChange)="handlePaginationClick.emit($event)" class="pagination"></pagination-controls>
		<input class="h-10 !w-16 mr-4" [(ngModel)]="viewStateService.state.pageNumber" (input)="onPageChange()" />
	</div>
	<div *ngIf="csrTasksService.totalItems">
		<span class="semi-bold">Total Items:</span>
		{{ csrTasksService.totalItems }}
	</div>
</div>
